module.exports = __webpack_public_path__ + "img/wtsp.ff374df2.svg";